<script>
  export let scale = 1;
  export let color = "#323232";
</script>

<svg width={40 * scale} height={40 * scale} viewBox="-10 -10 37 34" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill={color} d="M17 13C17 13.5523 16.5523 14 16 14C15.4477 14 15 13.5523 15 13V1C15 0.447716 15.4477 0 16 0C16.5523 0 17 0.447715 17 1V13Z" />
  <path fill={color} d="M9.75 5.70096C10.75 6.27831 10.75 7.72169 9.75 8.29904L2.25 12.6292C1.25 13.2065 0 12.4848 0 11.3301V2.66987C0 1.51517 1.25 0.793485 2.25 1.37083L9.75 5.70096Z" />
</svg>
